import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';
import { DynamicFormControlOption } from '@shared/dynamic-form';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';
import {
  HrpMultiselectComponent,
  HrpMultiselectOptionComponent,
  HrpMultiselectSearchbarComponent,
} from '@shared/ui/multiselect';
import { SearchPipe } from '@shared/utils';

@Component({
  selector: 'dynamic-form-multiselect-control',
  templateUrl: 'multiselect-control.component.html',
  styleUrls: ['multiselect-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ParFormFieldComponent,

    HrpMultiselectComponent,
    HrpMultiselectOptionComponent,
    HrpMultiselectSearchbarComponent,
    SearchPipe,
  ],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormMultiselectControlComponent,
    },
  ],
})
export class DynamicFormMultiselectControlComponent extends AbstractDynamicFormControl {
  displayNameFn = (options: DynamicFormControlOption[]) => (selected: string) => {
    return options?.find((o) => o.value === selected)?.key ?? selected;
  };
}
